import { CALL_API } from './../../middlewares/api';
import moment from 'moment';

const onLoadReservasIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_RESERVAS',
    endpoint: 'reservas',
    authenticated: true,
    config: {
      method: 'GET'
    }
  }
});

const onLoadReservas = () => (dispatch, getState) => {
  let {
    list: { fetching, errors }
  } = getState().reserva;
  if (!fetching && !errors.length) {
    dispatch(onLoadReservasIfNeeded());
  }
};

const onCreateReservas = ({ value, isNew = true }) => (dispatch, getState) => {
  if (getState().guiaInterativo.run) {
    return dispatch({
      type: 'CREATE_RESERVAS_SUCCESS_GUIA_INTERATIVO',
      isNew,
      value
    });
  }

  return dispatch({
    [CALL_API]: {
      type: 'CREATE_RESERVAS',
      endpoint: 'reservas',
      authenticated: true,
      config: {
        method: 'POST',
        redirect: 'follow',
        body: {
          unidade: value.unidade,
          ...(timezone => ({
            timezone,
            data_reserva: moment(value.data_reserva).utcOffset(timezone, true).format()
          }))(moment().format('Z'))
        }
      },
      success: r => {
        dispatch(onLoadReservasIfNeeded());
        return r.json;
      }
    },
    value
  });
};

const onApproveReservas = ({ value }) => (dispatch, getState) => {
  if (getState().guiaInterativo.run || !value.id) {
    return dispatch({
      type: 'APROVA_RESERVAS_SUCCESS_GUIA_INTERATIVO',
      value
    });
  }

  return dispatch({
    [CALL_API]: {
      type: 'APROVA_RESERVAS',
      endpoint: 'reservas',
      authenticated: true,
      config: {
        method: 'PUT',
        querystring: { id: value.id }
      },
      success: r => {
        dispatch(onLoadReservasIfNeeded());
        return r.json;
      }
    },
    value
  });
};

const onRemoveReservas = ({ value }) => ({
  type: 'CANCELA_RESERVAS_SUCCESS_REMOCAO',
  value
});

const onCancelReservas = ({ value, text }) => (dispatch, getState) => {
  if (getState().guiaInterativo.run) {
    return dispatch({
      type: 'CANCELA_RESERVAS_SUCCESS_GUIA_INTERATIVO',
      value: { ...value, motivo: text }
    });
  } else if (!value.id) {
    return dispatch(onRemoveReservas({ value }));
  }

  return dispatch({
    [CALL_API]: {
      type: 'CANCELA_RESERVAS',
      endpoint: 'reservas',
      authenticated: true,
      config: {
        method: 'DELETE',
        querystring: {
          id: value.id
        },
        body: {
          motivo: text,
          unidade: value.unidade
        }
      },
      success: r => {
        dispatch(onLoadReservasIfNeeded());
        return r.json;
      }
    },
    value
  });
};

const onChange = (key, value) => ({
  type: 'CHANGE_DATA_RESERVAS',
  value: { key, value }
});

export default {
  onChange,
  onLoadReservas,
  onCreateReservas,
  onApproveReservas,
  onCancelReservas,
  onRemoveReservas
};



// WEBPACK FOOTER //
// ./src/modules/reserva/actions.js